import { faUpload } from '@fortawesome/pro-regular-svg-icons';
import { faRefresh } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FormError } from '@kcftech/design-system';
import * as React from 'react';
import { inputAcceptByFileType } from 'utils/file';

export type FileUploadButtonProps = Readonly<{
    onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
    buttonLabel: string;
    buttonAppearance?: 'primary' | 'secondary' | 'tertiary' | 'subtle';
    buttonSpacing?: 'none' | 'medium' | 'compact' | 'large' | undefined;
    error?: string;
    isError?: boolean;
    isMultiFile?: boolean;
    isUploading: boolean;
    fileInputRef: React.RefObject<HTMLInputElement> | null;
    onButtonClick?: () => void;
    absolutePositionedSpinner?: boolean;
    fileType: keyof typeof inputAcceptByFileType;
}>;

export function FileUploadButton({
    onUpload,
    buttonLabel,
    buttonAppearance = 'primary',
    buttonSpacing = 'compact',
    error,
    isError,
    isMultiFile,
    isUploading,
    fileInputRef,
    onButtonClick,
    absolutePositionedSpinner,
    fileType,
}: FileUploadButtonProps) {
    return (
        <div style={{ display: 'block' }}>
            <div className="flex align-center">
                <input
                    ref={fileInputRef}
                    type="file"
                    multiple={isMultiFile}
                    accept={inputAcceptByFileType[fileType]}
                    // We must use opacity to hide the input here, because "display: none"
                    // and "visibility: hidden" would also semantically hide the input and
                    // render it inaccessible.
                    style={{ opacity: 0, width: '0.1px' }}
                    onChange={onUpload}
                    disabled={isUploading}
                />
                <Button
                    type="button"
                    appearance={buttonAppearance}
                    icon={
                        <FontAwesomeIcon
                            icon={isUploading ? faRefresh : faUpload}
                            spin={isUploading}
                        />
                    }
                    spacing={buttonSpacing}
                    onClick={onButtonClick}
                    disabled={isUploading}
                    ariaLabel={buttonLabel}
                >
                    {buttonLabel}
                </Button>
            </div>
            {isError && absolutePositionedSpinner && <FormError message={error} />}
        </div>
    );
}
